import { SvgIcon } from "@mui/material"

import { ReactComponent as RiskZones } from "./Icone_zones-a-risque.svg"

export const RiskZonesIcon = (props) => {
    return (
        <SvgIcon component={RiskZones} {...props} inheritViewBox />
    )
}